document.addEventListener('click', async (event) => {
  const button = event.target.closest('.tcs-unified-add');
  if (!button || button.disabled) return;

  const originalText = button.textContent.trim();
  button.disabled = true;
  button.textContent = 'Adding...';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: ['cart-drawer-section', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Unable to add product');

    const parser = new DOMParser();
    for (const [sectionName, selector] of [
      ['cart-drawer-section', '#cart-drawer'],
      ['cart-icon-bubble', '#cart-icon-bubble'],
    ]) {
      if (!data.sections?.[sectionName]) continue;
      const parsed = parser.parseFromString(data.sections[sectionName], 'text/html');
      const nextElement = parsed.querySelector(selector);
      const currentElement = document.querySelector(selector);
      if (nextElement && currentElement) currentElement.replaceWith(nextElement);
    }

    const drawer = document.querySelector('#cart-drawer');
    const drawerHost = drawer?.closest('theme-drawer') || drawer;
    if (typeof drawerHost?.open === 'function') drawerHost.open();
    else drawer?.setAttribute('open', '');
  } catch (error) {
    console.error('[Product card] Add to cart failed:', error);
  } finally {
    button.textContent = originalText;
    button.disabled = false;
  }
});
